import React, {useEffect} from 'react'
import { StyleSheet, View, Text, ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import client, { useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import { updateNotificationStatus, testID } from '@sart/utilities'

import { Barcode } from '../Components';
import {
    Title,
    Button,
    Description,
    Space
  } from '@sart/components'
  
import { CompanyIcon } from '@sart/icons'

export default function Confirmation(props) {
  const {
    cache
  } = useClient()
  const content = useContent()

  const { navigation, route } = props

  const barCode = route.params?.barCode
  const total = route.params?.total

  useEffect(() => {
    client.clearCachedPayment()
		checkAndCompleteNotification(client.cache.basket)
    // basketHelper.clearCacheBasket()
    client.setCache({basket: []})
  },[])

  function calculateTotalCost(){
    return (total / 100).toFixed(2) 
  }

	function checkAndCompleteNotification(basket) {
		if(client.cache.promoNotification !== undefined) {
			let notification = client.cache.promoNotification
			let basketItems = basket.serviceItems
			let promoProductPurchased = false
			let ppp = notification.ppp
			if (ppp !== undefined && ppp.length > 0 && basketItems !== undefined && basketItems.length > 0) {
				for(var j = 0; j < ppp.length; j++) {
					for(var i = 0; i < basketItems.length; i++) {
						if(ppp[j].productId === basketItems[i].productId) {
							promoProductPurchased = true
						}
					}
				}
			}
			if (promoProductPurchased) {
				updateNotificationStatus(notification, 'completed')
			}
			client.unsetCache("promoNotification")
		}
	}

  return (
    <ScrollView style={styles.container}>
      <View style={styles.wrapper}>        
        <Space height={48} />
        <View style={{ alignItems: 'center' }}>
        <CompanyIcon color={colors.srGreen} height={150} width={150}/>
        </View>
        <Space height={24} />        
      
        <Title style={styles.title} {...testID('CashConfirmation')}>{content.payment_confirm.almostDone}</Title>
        <Space height={12} />        

        <Description style={styles.description}>{content.payment_confirm.cashDescription}</Description>
        <Space height={12} />        
        {/* Unsure if 'CODE128' format is correct */}
        <Barcode lineColor={colors.srGreen} textColor={colors.srGreen} value={barCode} format={'CODE128'} text={barCode} width={styles.barcodeSize.width} {...testID('CashBarcode')}/>
        <Description style={styles.price}>{content.checkout.total} £{calculateTotalCost()} {content.payment_confirm.currencyCode}</Description>
        <Space height={24} />
        
        <Button
          style={styles.button}
          title={content.payment_confirm.action}
          onPress={() => {
            navigation.popToTop()
            navigation.navigate('Dashboard')
          }}
          titleStyle={{...typography.extrabold, fontSize: 18}}
          {...testID('CashConfirmationButton')}
        />
        <Space height={24} />        
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    ...adaptive.wrapperPadding,
  },
  wrapper: {
    flex: 1,
    backgroundColor: colors.white,
    ...adaptive.wrapperPadding,
    // justifyContent: 'center',
    alignItems: 'center'  
},
  title: {
    color: colors.srGreen,
    ...typography.bold,
    fontSize: 24
  },
  description: {
    color: colors.srGreen,
    textAlign: 'center',
    ...typography.lightbold
  },
  button: {
      backgroundColor: colors.srGreen,
      width: 300,
      height: 50
  },
  barcodeSize: {
    width: 2.48
  },
  price: {
    backgroundColor: colors.white,
    color: colors.srGreen,
    ...typography.lightbold,
    textAlign: 'center',
    width: 300
  }
})
